import { render, staticRenderFns } from "./DraftDAStatusChip.vue?vue&type=template&id=78a2c66d"
import script from "./DraftDAStatusChip.vue?vue&type=script&lang=js"
export * from "./DraftDAStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports